import {Component,OnInit,ViewChild} from '@angular/core';
import {ActivatedRoute,ParamMap} from '@angular/router';
import {JhiAlertService,JhiParseLinks} from 'ng-jhipster';
import {ModalDirective} from 'ngx-bootstrap';
import {FinscanEntity} from 'src/app/shared/model/fin-scan-opportunities.model';
import {LanguageChangeService} from 'src/app/shared/services/language-change.service';
import {RoleUtil} from 'src/app/shared/util/role-util';
import {CertificateMySuffixService} from '../certificate-client/certificate-client.service';
import {Principal} from './../../core/auth/principal.service';
import {ITEMS_PER_PAGE} from './../../shared/constants/pagination.constants';
import {VesselInformationMySuffixService} from './vessel-information-my-suffix.service';



@Component({
  selector: 'jhi-vessel-screening-my-suffix.component',
  templateUrl: './vessel-screening-my-suffix.component.html'
})
export class VesselScreeningMySuffixComponent implements OnInit {

  @ViewChild('subRuleInfo') subRuleInfo: ModalDirective;

  public readonly RoleUtil = RoleUtil;
    
  //pagination
  links: any;
  totalItems: any;
  queryCount: any;
  itemsPerPage: any;
  page: any;
  predicate: any;
  previousPage: any;
  routeData: any;
  reverse: any;
  isSanctionScreeningEnabled = false;
  currentAccount: any;
  

  subRuleInfoMessages = [];
  vesselScreening = [];
  constructor(private activatedRoute: ActivatedRoute,
    private certificateService: CertificateMySuffixService,
    private vesselInformationMySuffixService: VesselInformationMySuffixService,
    private jhiAlertService: JhiAlertService,
    private parseLinks: JhiParseLinks,
    public principal: Principal,
    private languageChangeService:LanguageChangeService,
  ) {

    this.itemsPerPage = ITEMS_PER_PAGE;
    this.routeData = this.activatedRoute.data.subscribe(data => {
      this.page = data.pagingParams.page;
      this.previousPage = data.pagingParams.page;
      this.reverse = data.pagingParams.ascending;
      this.predicate = data.pagingParams.predicate;
    });

    this.languageChangeService.refreshLanguage();
    this.activatedRoute.queryParamMap.subscribe((paramMap: ParamMap) => {
      if (paramMap.get('size')) {
        this.itemsPerPage = paramMap.get('size');
      }
       const refresh = paramMap.get('refresh');
       if (refresh) {
           this.languageChangeService.refreshLanguage();
       }
});
  }

  ngOnInit() {
    this.principal.setTitle("Vessel Screening");
    this.getVesselScreening();
   console.log(this.previousPage);
   
    //   this.principal.identity().then(account => {
    //   this.currentAccount = account;
    //   this.isSanctionScreeningEnabled = this.currentAccount.enableSanctionsScreening
    // });

    this.isSanctionScreeningEnabled=this.principal.checkForEnableSanctionScreeningForFinscanEntity(FinscanEntity.VESSELS);

  }

  loadPage(page: number) {
    if (page !== this.previousPage) {
        this.previousPage = page;
        this.getVesselScreening();
    }
}

clear() {
    this.page = 1;
    this.getVesselScreening();
}

  getVesselScreening() {
    this.vesselInformationMySuffixService.getWithPageAble("vessel-screening-all",
    {
      page: this.page - 1,
      size: this.itemsPerPage,
    }).subscribe(res => {
      this.vesselScreening = res.body;

      this.links = this.parseLinks.parse(res.headers.get('link'));
      this.totalItems = parseInt(res.headers.get('X-Total-Count'), 10);
      this.queryCount = this.totalItems;

    }, err => {
      this.jhiAlertService.error(err.message);
    });
  }

  viewSubInfo(data:any){
    console.log("view subInfo",data);
    
    this.subRuleInfoMessages = data;
    this.showSubRuleInfo();
  }

  previousState() {
    window.history.back();
  }


  hideSubRuleInfo() {
    this.subRuleInfo.hide();
  }

  showSubRuleInfo() {
    this.subRuleInfo.show();
  }
  onChange(value) {
    this.page = 0;
    this.itemsPerPage = value
    this.getVesselScreening();
  }


}
